// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__niE3Y","imageUploader":"EGiftCard_imageUploader__3Gtfp"};